import { defineStore } from "pinia";

interface State {
  showSidebar: boolean,
  _sidebarLinks: string[],
  _isMinimized: boolean,
}

export const useSidebar = defineStore('sidebar', {
  state: (): State => ({
    showSidebar: false,
    _sidebarLinks: [],
    _isMinimized: false,
  }),

  actions: {
    displaySidebar(value: boolean) {
      this.$state.showSidebar = value;
    },
    toggleMinimize() {
      document.body.classList.toggle('sidebar-mini');
      // we simulate the window Resize so the charts will get updated in realtime.
      const simulateWindowResize = setInterval(() => {
        window.dispatchEvent(new Event('resize'));
      }, 180);

      // we stop the simulation of Window Resize after the animations are completed
      setTimeout(() => {
        clearInterval(simulateWindowResize);
      }, 1000);

      this.$state._isMinimized = !this.$state._isMinimized;
    }
  }
})
